const config = {
  authUrl: process.env.REACT_APP_AUTH_URL,
  apiUrl: process.env.REACT_APP_API_URL,
  viewer: {
    canvasId: 'viewer',
  }
};

export default config;
